import { render } from "./HealthDetails.vue?vue&type=template&id=08d153c4"
import script from "./HealthDetails.vue?vue&type=script&lang=js"
export * from "./HealthDetails.vue?vue&type=script&lang=js"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__